import ReactDOM from 'react-dom/client';
import { TenantContext } from '../../../context/tenant-context';
import { v2Component } from '../../../index';
import { StatusTransitionButtons } from './status-transition-buttons';

export function initOrderStatusTransitionButtons() {
  document.getElementsByName('order-status-transitions').forEach((element) => {
    if (element.getAttribute('initialized') !== 'true') {
      element.setAttribute('initialized', 'true');
      const root = ReactDOM.createRoot(element);

      const bootstrap = () => {
        const { tenant, contextPath, orderId } = Object.assign({}, element.dataset) as any;
        root.render(
          v2Component(
            <TenantContext.Provider value={{ tenant, contextPath, spaMode: false }}>
              <StatusTransitionButtons orderId={orderId} />
            </TenantContext.Provider>,
          ),
        );
      };

      bootstrap();
    }
  });
}
